
{
  "familyId": "TGL-TIJD-SNELHEID",
  "questions": [
    {
      "id": "TGL-TIJD-SNELHEID-001",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een auto rijdt 120 km in 2 uur. Wat is de gemiddelde snelheid?",
      "options": ["60 km/u", "240 km/u", "122 km/u", "118 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_basic",
      "variantIndex": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Snelheid berekenen",
            "content": "Snelheid = afstand ÷ tijd. Hier: 120 km ÷ 2 uur = 60 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Snelheid = afstand ÷ tijd = 120 ÷ 2 = 60 km/u.",
        "distractorExplanations": {
          "0": "Goed! 120 ÷ 2 = 60 km/u.",
          "1": "Je hebt 120 × 2 gerekend (vermenigvuldigd). Snelheid = afstand ÷ tijd = 120 ÷ 2 = 60 km/u.",
          "2": "Je hebt 120 + 2 gerekend. Snelheid = afstand ÷ tijd = 120 ÷ 2 = 60 km/u.",
          "3": "Je hebt 120 − 2 gerekend. Snelheid = afstand ÷ tijd = 120 ÷ 2 = 60 km/u."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-002",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een fietser rijdt met 15 km/u. Hoe ver komt hij in 3 uur?",
      "options": ["45 km", "5 km", "18 km", "12 km"],
      "correctAnswer": 0,
      "conceptId": "distance_from_speed",
      "variantIndex": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand berekenen",
            "content": "Afstand = snelheid × tijd. Hier: 15 km/u × 3 uur = 45 km.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Afstand = snelheid × tijd = 15 × 3 = 45 km.",
        "distractorExplanations": {
          "0": "Goed! 15 × 3 = 45 km.",
          "1": "Je hebt 15 ÷ 3 gerekend (gedeeld). Afstand = snelheid × tijd = 15 × 3 = 45 km.",
          "2": "Je hebt 15 + 3 gerekend. Afstand = snelheid × tijd = 15 × 3 = 45 km.",
          "3": "Je hebt 15 − 3 gerekend. Afstand = snelheid × tijd = 15 × 3 = 45 km."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-003",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een trein rijdt 180 km in 3 uur. Wat is de gemiddelde snelheid?",
      "options": ["60 km/u", "540 km/u", "183 km/u", "177 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_train",
      "variantIndex": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Snelheid berekenen",
            "content": "Snelheid = afstand ÷ tijd = 180 ÷ 3 = 60 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Snelheid = afstand ÷ tijd = 180 ÷ 3 = 60 km/u.",
        "distractorExplanations": {
          "0": "Goed! 180 ÷ 3 = 60 km/u.",
          "1": "Je hebt 180 × 3 gerekend. Snelheid = afstand ÷ tijd = 180 ÷ 3 = 60 km/u.",
          "2": "Je hebt 180 + 3 gerekend. Snelheid = 180 ÷ 3 = 60 km/u.",
          "3": "Je hebt 180 − 3 gerekend. Snelheid = 180 ÷ 3 = 60 km/u."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-004",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een hardloper rent met 12 km/u. Hoe lang doet hij over 6 km?",
      "options": ["30 minuten", "72 minuten", "18 minuten", "2 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_from_speed",
      "variantIndex": 4,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijd berekenen",
            "content": "Tijd = afstand ÷ snelheid = 6 ÷ 12 = 0,5 uur = 30 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Tijd = afstand ÷ snelheid = 6 ÷ 12 = 0,5 uur = 30 minuten.",
        "distractorExplanations": {
          "0": "Goed! 6 ÷ 12 = 0,5 uur = 30 minuten.",
          "1": "Je hebt 12 × 6 = 72 gerekend. Maar tijd = afstand ÷ snelheid = 6 ÷ 12 = 0,5 uur = 30 minuten.",
          "2": "Je hebt 12 + 6 = 18 gerekend. Tijd = afstand ÷ snelheid = 6 ÷ 12 = 0,5 uur = 30 minuten.",
          "3": "Je hebt 12 − 6 = 6 gerekend, of een andere berekening. Tijd = 6 ÷ 12 = 0,5 uur = 30 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-005",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een bus rijdt met 50 km/u. Hoe ver komt hij in 2,5 uur?",
      "options": ["125 km", "20 km", "52,5 km", "100 km"],
      "correctAnswer": 0,
      "conceptId": "distance_decimal_time",
      "variantIndex": 5,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand met decimale tijd",
            "content": "Afstand = snelheid × tijd = 50 × 2,5 = 125 km.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Afstand = snelheid × tijd = 50 × 2,5 = 125 km.",
        "distractorExplanations": {
          "0": "Goed! 50 × 2,5 = 125 km.",
          "1": "Je hebt 50 ÷ 2,5 gerekend. Afstand = snelheid × tijd = 50 × 2,5 = 125 km.",
          "2": "Je hebt 50 + 2,5 gerekend. Afstand = 50 × 2,5 = 125 km.",
          "3": "Je hebt 50 × 2 gerekend, maar het zijn 2,5 uur. 50 × 2,5 = 125 km."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-006",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een vliegtuig legt 900 km af in 1,5 uur. Wat is de gemiddelde snelheid?",
      "options": ["600 km/u", "1350 km/u", "901,5 km/u", "450 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_airplane",
      "variantIndex": 6,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Snelheid met decimale tijd",
            "content": "Snelheid = afstand ÷ tijd = 900 ÷ 1,5 = 600 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Snelheid = afstand ÷ tijd = 900 ÷ 1,5 = 600 km/u.",
        "distractorExplanations": {
          "0": "Goed! 900 ÷ 1,5 = 600 km/u.",
          "1": "Je hebt 900 × 1,5 gerekend. Snelheid = afstand ÷ tijd = 900 ÷ 1,5 = 600 km/u.",
          "2": "Je hebt 900 + 1,5 gerekend. Snelheid = 900 ÷ 1,5 = 600 km/u.",
          "3": "Je hebt 900 ÷ 2 gerekend, maar het zijn 1,5 uur, niet 2. 900 ÷ 1,5 = 600 km/u."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-007",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een auto rijdt 150 km in 2,5 uur. Wat is de gemiddelde snelheid?",
      "options": ["60 km/u", "375 km/u", "152,5 km/u", "75 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_decimal_time",
      "variantIndex": 7,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Snelheid berekenen",
            "content": "Snelheid = afstand ÷ tijd = 150 ÷ 2,5 = 60 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Snelheid = afstand ÷ tijd = 150 ÷ 2,5 = 60 km/u.",
        "distractorExplanations": {
          "0": "Goed! 150 ÷ 2,5 = 60 km/u.",
          "1": "Je hebt 150 × 2,5 gerekend. Snelheid = afstand ÷ tijd = 150 ÷ 2,5 = 60 km/u.",
          "2": "Je hebt 150 + 2,5 gerekend. Snelheid = 150 ÷ 2,5 = 60 km/u.",
          "3": "Je hebt 150 ÷ 2 gerekend, maar het zijn 2,5 uur. 150 ÷ 2,5 = 60 km/u."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-008",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een fietser rijdt met 20 km/u. Hoe ver komt hij in 4 uur?",
      "options": ["80 km", "5 km", "24 km", "16 km"],
      "correctAnswer": 0,
      "conceptId": "distance_from_speed_4h",
      "variantIndex": 8,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand berekenen",
            "content": "Afstand = snelheid × tijd = 20 × 4 = 80 km.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Afstand = snelheid × tijd = 20 × 4 = 80 km.",
        "distractorExplanations": {
          "0": "Goed! 20 × 4 = 80 km.",
          "1": "Je hebt 20 ÷ 4 gerekend. Afstand = snelheid × tijd = 20 × 4 = 80 km.",
          "2": "Je hebt 20 + 4 gerekend. Afstand = 20 × 4 = 80 km.",
          "3": "Je hebt 20 − 4 gerekend. Afstand = snelheid × tijd = 20 × 4 = 80 km."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-009",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een wandelaar loopt 10 km in 2 uur. Wat is de gemiddelde snelheid?",
      "options": ["5 km/u", "20 km/u", "12 km/u", "8 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_walking",
      "variantIndex": 9,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Snelheid berekenen",
            "content": "Snelheid = afstand ÷ tijd = 10 ÷ 2 = 5 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Snelheid = afstand ÷ tijd = 10 ÷ 2 = 5 km/u.",
        "distractorExplanations": {
          "0": "Goed! 10 ÷ 2 = 5 km/u.",
          "1": "Je hebt 10 × 2 gerekend. Snelheid = afstand ÷ tijd = 10 ÷ 2 = 5 km/u.",
          "2": "Je hebt 10 + 2 gerekend. Snelheid = 10 ÷ 2 = 5 km/u.",
          "3": "Je hebt 10 − 2 gerekend. Snelheid = afstand ÷ tijd = 10 ÷ 2 = 5 km/u."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-010",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een scooter rijdt met 40 km/u. Hoe lang doet hij over 20 km?",
      "options": ["30 minuten", "80 minuten", "60 minuten", "20 minuten"],
      "correctAnswer": 0,
      "conceptId": "time_from_speed_half_hour",
      "variantIndex": 10,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Tijd berekenen",
            "content": "Tijd = afstand ÷ snelheid = 20 ÷ 40 = 0,5 uur = 30 minuten.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Tijd = afstand ÷ snelheid = 20 ÷ 40 = 0,5 uur = 30 minuten.",
        "distractorExplanations": {
          "0": "Goed! 20 ÷ 40 = 0,5 uur = 30 minuten.",
          "1": "Je hebt 40 × 20 gerekend. Maar tijd = afstand ÷ snelheid = 20 ÷ 40 = 0,5 uur = 30 minuten.",
          "2": "60 minuten is 1 uur. Maar 20 ÷ 40 = 0,5 uur = 30 minuten, niet 1 uur.",
          "3": "Je hebt de afstand als antwoord genomen. Tijd = afstand ÷ snelheid = 20 ÷ 40 = 0,5 uur = 30 minuten."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-011",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een motor rijdt 240 km in 4 uur. Wat is de gemiddelde snelheid?",
      "options": ["60 km/u", "960 km/u", "244 km/u", "236 km/u"],
      "correctAnswer": 0,
      "conceptId": "speed_motorcycle",
      "variantIndex": 11,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Snelheid berekenen",
            "content": "Snelheid = afstand ÷ tijd = 240 ÷ 4 = 60 km/u.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Snelheid = afstand ÷ tijd = 240 ÷ 4 = 60 km/u.",
        "distractorExplanations": {
          "0": "Goed! 240 ÷ 4 = 60 km/u.",
          "1": "Je hebt 240 × 4 gerekend. Snelheid = afstand ÷ tijd = 240 ÷ 4 = 60 km/u.",
          "2": "Je hebt 240 + 4 gerekend. Snelheid = 240 ÷ 4 = 60 km/u.",
          "3": "Je hebt 240 − 4 gerekend. Snelheid = afstand ÷ tijd = 240 ÷ 4 = 60 km/u."
        }
      }
    },
    {
      "id": "TGL-TIJD-SNELHEID-012",
      "familyId": "TGL-TIJD-SNELHEID",
      "module": "TijdGeld",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "snelheid",
      "subSkill": "snelheid_berekenen",
      "questionType": "multiple_choice",
      "question": "Een trein rijdt met 80 km/u. Hoe ver komt hij in 1,5 uur?",
      "options": ["120 km", "53,3 km", "81,5 km", "160 km"],
      "correctAnswer": 0,
      "conceptId": "distance_decimal_time_train",
      "variantIndex": 12,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand met decimale tijd",
            "content": "Afstand = snelheid × tijd = 80 × 1,5 = 120 km.",
            "icon": "lightbulb"
          }
        }
      ],
      "feedback": {
        "explanationText": "Afstand = snelheid × tijd = 80 × 1,5 = 120 km.",
        "distractorExplanations": {
          "0": "Goed! 80 × 1,5 = 120 km.",
          "1": "Je hebt 80 ÷ 1,5 gerekend. Afstand = snelheid × tijd = 80 × 1,5 = 120 km.",
          "2": "Je hebt 80 + 1,5 gerekend. Afstand = 80 × 1,5 = 120 km.",
          "3": "Je hebt 80 × 2 gerekend, maar het zijn 1,5 uur. 80 × 1,5 = 120 km."
        }
      }
    }
  ]
}
